import {amazonProviderId, amazonModule} from './idp/amazon'
import {facebookProviderId, facebookModule} from './idp/facebook'
import {googleProviderId, googleModule} from './idp/google'

const providerIds = [
  amazonProviderId,
  facebookProviderId,
  googleProviderId
]

const account = {
  state: {

    /**
     * Cognito Login tokens
     */
    tokens: {
    }
  },
  getters: {
    loginTokens: state => {
      return state.tokens
    },
    authEmailAddress: (state, getters) => {
      return getters.googleEmailAddress || getters.facebookEmailAddress || getters.amazonEmailAddress
    },
    authName: (state, getters) => {
      return getters.googleName || getters.facebookName || getters.amazonName
    },
    authFirstName: (state, getters) => {
      return getters.authName.split(' ')[0] || ''
    },
    authLastName: (state, getters) => {
      const parts = getters.authName.split(' ')

      if (parts.length > 0) {
        return parts[parts.length - 1]
      }
      return ''
    }
  },
  mutations: {
    /**
     * Update the login entry object when the object changes
     */
    updateLoginEntry: (state, entry) => {
      providerIds.forEach((providerId) => {
        if (entry[providerId]) {
          state.tokens[providerId] = entry[providerId]
          console.log('Added Login provider: %s : %s', providerId, entry[providerId])
        } else if (entry[providerId] === '' && state.tokens[providerId]) {
          delete state.tokens[providerId]
          console.log('Deleted Login provider: %s : %s', providerId, entry[providerId])
        } else {
          // No provider changes to make
        }
      })
    }
  },
  actions: {
    /**
     * Login entry change action
     */
    loginEntryChange (context, entry) {
      context.commit('updateLoginEntry', entry)

      /**
       * Cognito Login Here
       */
      context.dispatch('getCognitoCredentials')
    }
  },
  modules: {
    'idp': {
      modules: {
        'amazon': amazonModule,
        'facebook': facebookModule,
        'google': googleModule
      }
    }
  }
}

export default account



// WEBPACK FOOTER //
// ./src/store/auth/index.js